import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function StokMasuk() {
  const [barang, setBarang] = useState([])
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [form, setForm] = useState({ KodeBarang: '', Qty: '', HargaBeli: '', TglMasuk: new Date().toISOString().slice(0, 10), Supplier: '', Keterangan: '' })
  const [submitting, setSubmitting] = useState(false)

  const fetchBarang = async () => {
    try {
      const res = await serbaUsahaService.getBarang({ limit: 200 })
      setBarang(res.data.data || [])
    } catch { }
  }

  const fetchHistory = async () => {
    try {
      setLoading(true)
      const res = await serbaUsahaService.getStokMasuk({ page, limit: 20 })
      setHistory(res.data.data || [])
      setTotalPages(res.data.meta?.totalPages || 1)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  useEffect(() => { fetchBarang(); fetchHistory() }, [page])

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)
  const formatDate = (d) => {
    if (!d) return '-'
    return new Date(d).toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.KodeBarang || !form.Qty || !form.HargaBeli || !form.TglMasuk) {
      return alert('Lengkapi semua field')
    }
    setSubmitting(true)
    try {
      await serbaUsahaService.createStokMasuk(form)
      alert('Stok berhasil ditambahkan')
      setForm({ KodeBarang: '', Qty: '', HargaBeli: '', TglMasuk: new Date().toISOString().slice(0, 10), Supplier: '', Keterangan: '' })
      fetchHistory()
    } catch (err) { alert('Gagal: ' + (err.response?.data?.message || err.message)) }
    finally { setSubmitting(false) }
  }

  return (
    <div className="row">
      <div className="col-md-5">
        <div className="card">
          <div className="card-header"><h3 className="card-title">Tambah Stok Masuk</h3></div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Barang</label>
                <select className="form-control" value={form.KodeBarang} onChange={e => setForm({...form, KodeBarang: e.target.value})} required>
                  <option value="">-- Pilih Barang --</option>
                  {barang.filter(b => b.IsActive).map((b, i) => (
                    <option key={i} value={b.KodeBarang}>{b.KodeBarang} - {b.NamaBarang} (stok: {b.Stok})</option>
                  ))}
                </select>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Qty</label>
                    <input type="number" className="form-control" value={form.Qty} onChange={e => setForm({...form, Qty: e.target.value})} required min="1" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Harga Beli (Rp)</label>
                    <input type="number" className="form-control" value={form.HargaBeli} onChange={e => setForm({...form, HargaBeli: e.target.value})} required min="0" />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>Tgl Masuk</label>
                <input type="date" className="form-control" value={form.TglMasuk} onChange={e => setForm({...form, TglMasuk: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Supplier</label>
                <input className="form-control" value={form.Supplier} onChange={e => setForm({...form, Supplier: e.target.value})} placeholder="(opsional)" />
              </div>
              <div className="form-group">
                <label>Keterangan</label>
                <textarea className="form-control" value={form.Keterangan} onChange={e => setForm({...form, Keterangan: e.target.value})} placeholder="(opsional)" rows="2" />
              </div>
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? <i className="fas fa-spinner fa-spin"></i> : 'Simpan'}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="col-md-7">
        <div className="card">
          <div className="card-header"><h3 className="card-title">Riwayat Stok Masuk</h3></div>
          <div className="card-body">
            {loading ? <div className="text-center py-3"><i className="fas fa-spinner fa-spin fa-2x"></i></div> : (
              <table className="table table-bordered table-hover">
                <thead><tr>
                  <th>Tgl</th><th>Barang</th><th>Qty</th><th>Harga Beli</th><th>Supplier</th>
                </tr></thead>
                <tbody>
                  {history.length === 0 ? <tr><td colSpan="5" className="text-center">Belum ada stok masuk</td></tr> :
                    history.map((h, i) => (
                      <tr key={i}>
                        <td>{formatDate(h.TglMasuk)}</td>
                        <td>{h.NamaBarang || h.KodeBarang}</td>
                        <td className="text-center">{h.Qty}</td>
                        <td className="text-right">{formatCurrency(h.HargaBeli)}</td>
                        <td>{h.Supplier || '-'}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                {Array.from({ length: totalPages }, (_, i) => (
                  <button key={i} className={`btn btn-sm ${page === i + 1 ? 'btn-primary' : 'btn-default'} mx-1`} onClick={() => setPage(i + 1)}>{i + 1}</button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default StokMasuk
